import React, { useLayoutEffect } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { ViewportConfigProvider, ReturnsConfigProvider } from '@narvar/nth-kit-returns-headless';
import ReturnsApolloProvider from '../../../react-components/ApolloProvider';
import { mapTheme } from './theme';
import { LOMA_URL } from '../../../constants/hosts';

const mapStateToProps = ({
  page: { languageCode, countryCode } = {},
  retailerSettings: { name, branding } = {},
}) => ({
  retailerName: name,
  languageCode,
  countryCode,
  branding,
});

export const NthContextProvider = ({
  children,
  retailerName,
  languageCode,
  countryCode,
  branding,
}) => {
  useLayoutEffect(() => {
    window.dispatchEvent(new Event('resize'));
  });

  const theme = mapTheme(branding);
  const translations = {
    returnsReasonsExchangeTitle: ' ',
  };
  const globalSettings = {
    retailerName,
    defaultLanguage: languageCode,
    defaultCountry: countryCode,
    defaultVersionName: '',
    fallbackVersionName: '',
    returnsWorkflowActiveVersion: '',
    returnsWorkflowDefaultVersion: '',
  };

  const handleAnalyticsError = (error) => console.error(error);

  return (
    <ReturnsApolloProvider>
      <ReturnsConfigProvider
        handleError={handleAnalyticsError}
        moniker={retailerName}
        localeLanguage={languageCode}
        localeCountry={countryCode}
        localConfig={{
          queryTheme: () => theme,
          queryTranslations: () => translations,
          queryGlobalSettings: () => globalSettings,
        }}
        lomaUrl={LOMA_URL}
      >
        <ViewportConfigProvider
          config={{
            anchor: { offsetTop: 0, offsetBottom: 0 },
          }}
        >
          {children}
        </ViewportConfigProvider>
      </ReturnsConfigProvider>
    </ReturnsApolloProvider>
  );
};

NthContextProvider.defaultProps = {
  children: undefined,
  branding: {},
};

NthContextProvider.propTypes = {
  children: PropTypes.node,
  retailerName: PropTypes.string.isRequired,
  languageCode: PropTypes.string.isRequired,
  countryCode: PropTypes.string.isRequired,
  branding: PropTypes.object,
};

export default connect(mapStateToProps)(NthContextProvider);
